module.exports = __webpack_public_path__ + "media/shot.04f4dc3b.webm";